import React from "react";

import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleState } from "../../redux/reducers/ModuleStateReducer";
import { getModuleTemperatureChanged } from "../../redux/reducers/TemperatureReducer";

import { Module } from "../../Model/Module";
import { EModuleType } from "../../Model/EModuleType";
import { ETemperatureState } from "../../Model/ETemperatureState";

import OverviewStatus, { EOverviewModuleStatus } from "./OverviewStatus";

type ChamberStatusProps = {
  module: Module;
};

export default function ChamberStatus(props: ChamberStatusProps) {
  const { module } = props;
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, module.identifier)
  );
  const chamberTemperatureChange = useTypedSelector((state) =>
    getModuleTemperatureChanged(state, module.identifier)
  );

  const chamberState = moduleState.chamber;
  const remainingCapacity = chamberState ? chamberState.remainingCapacity : 0;
  const fullCapacity = chamberState ? chamberState.fullCapacity : 0;

  const availableStorage = `${remainingCapacity} of ${fullCapacity}`;
  const mainDoorText = chamberState?.isMainDoorOpen ? "Open" : "Secured";
  const interiorLightText = chamberState?.interiorLight ? "On" : "Off";

  const statusses = {
    "Available Storage": availableStorage,
    ...(chamberState?.isMainDoorOpen ? { "Main Door": mainDoorText } : {}),
    ...(chamberState?.interiorLight
      ? { "Interior Light": interiorLightText }
      : {}),
  };

  const moduleStatus =
    chamberTemperatureChange.state === ETemperatureState.Violation
      ? EOverviewModuleStatus.Error
      : EOverviewModuleStatus.Idle;

  return (
    <OverviewStatus
      moduleType={EModuleType.CHAMBER}
      name={module.name}
      statusses={statusses}
      moduleStatus={moduleStatus}
    />
  );
}
